// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stockIndetails {
  width: 100%;
  border-collapse: collapse;
  margin: 1rem 0;
  font-size: 1rem;
}

.stockIndetails th,
.stockIndetails td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

.stockIndetails th {
  background-color: #f8f8f8;
  font-weight: bold;
}

@media (max-width: 768px) {
  .stockIndetails {
    font-size: 0.9rem;
  }
}

@media (max-width: 480px) {
  .stockIndetails,
  .stockIndetails thead,
  .stockIndetails tbody,
  .stockIndetails th,
  .stockIndetails td,
  .stockIndetails tr {
    display: block;
    width: 100%;
  }

  .stockIndetails thead tr {
    display: none;
  }

  .stockIndetails tr {
    margin-bottom: 1rem;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 0.5rem;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }

  .stockIndetails td {
    border: none;
    position: relative;
    padding-left: 50%;
    text-align: left;
  }

  .stockIndetails td::before {
    position: absolute;
    top: 0;
    left: 10px;
    width: 45%;
    white-space: nowrap;
    font-weight: bold;
  }

  .stockIndetails td:nth-of-type(1)::before {
    content: "ID";
  }
  .stockIndetails td:nth-of-type(2)::before {
    content: "Quantity Added";
  }
  .stockIndetails td:nth-of-type(3)::before {
    content: "Price Added";
  }
  .stockIndetails td:nth-of-type(4)::before {
    content: "Added At";
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/material/stockDetail.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;;;;;;IAME,cAAc;IACd,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,wCAAwC;EAC1C;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,UAAU;IACV,UAAU;IACV,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".stockIndetails {\n  width: 100%;\n  border-collapse: collapse;\n  margin: 1rem 0;\n  font-size: 1rem;\n}\n\n.stockIndetails th,\n.stockIndetails td {\n  border: 1px solid #ddd;\n  padding: 8px;\n  text-align: left;\n}\n\n.stockIndetails th {\n  background-color: #f8f8f8;\n  font-weight: bold;\n}\n\n@media (max-width: 768px) {\n  .stockIndetails {\n    font-size: 0.9rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .stockIndetails,\n  .stockIndetails thead,\n  .stockIndetails tbody,\n  .stockIndetails th,\n  .stockIndetails td,\n  .stockIndetails tr {\n    display: block;\n    width: 100%;\n  }\n\n  .stockIndetails thead tr {\n    display: none;\n  }\n\n  .stockIndetails tr {\n    margin-bottom: 1rem;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    padding: 0.5rem;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  }\n\n  .stockIndetails td {\n    border: none;\n    position: relative;\n    padding-left: 50%;\n    text-align: left;\n  }\n\n  .stockIndetails td::before {\n    position: absolute;\n    top: 0;\n    left: 10px;\n    width: 45%;\n    white-space: nowrap;\n    font-weight: bold;\n  }\n\n  .stockIndetails td:nth-of-type(1)::before {\n    content: \"ID\";\n  }\n  .stockIndetails td:nth-of-type(2)::before {\n    content: \"Quantity Added\";\n  }\n  .stockIndetails td:nth-of-type(3)::before {\n    content: \"Price Added\";\n  }\n  .stockIndetails td:nth-of-type(4)::before {\n    content: \"Added At\";\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
